'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _css = require('antd/lib/spin/style/css');

var _spin = require('antd/lib/spin');

var _spin2 = _interopRequireDefault(_spin);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _media_list_item = require('./media_list_item');

var _media_list_item2 = _interopRequireDefault(_media_list_item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MediaList = _react2.default.createClass({
    displayName: 'MediaList',

    propTypes: {
        media: _react.PropTypes.object.isRequired
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {},
    render: function render() {
        var _props = this.props,
            media = _props.media,
            onSelect = _props.onSelect,
            _props$selectedMedia = _props.selectedMedia,
            selectedMedia = _props$selectedMedia === undefined ? [] : _props$selectedMedia;
        var items = media.items,
            error = media.error,
            isFetching = media.isFetching,
            isPosting = media.isPosting;

        return _react2.default.createElement(
            _spin2.default,
            { spinning: isPosting || isFetching, size: 'large' },
            _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'ul',
                    { id: 'list-media' },
                    items.map(function (item, index) {
                        return _react2.default.createElement(_media_list_item2.default, { key: item.id, onSelect: onSelect && onSelect.bind(null, item), url: item.url, isSelected: onSelect && selectedMedia.find(function (x) {
                                return x.id == item.id;
                            }) ? true : false });
                    })
                )
            )
        );
    }
});

exports.default = MediaList;


//////////////////
// WEBPACK FOOTER
// ./src/js/components/media_list.js
// module id = 1470
// module chunks = 0